/* @flow */
import React from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';
import SnackbarContent from '@material-ui/core/SnackbarContent';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './ElectroMessageBarCont.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

/**
 * The message could be different type
 * oneOf(['success', 'warning', 'error', 'info'])
 */

const variantIcon: Object = {
  success: '#icon-approve',
  warning: '#icon-error',
  error: '#icon-declined',
  info: '#icon-information',
};

function MySnackbarContent(props: *): React.Element<*> {
  const { message, linkto, variant, ...other }: * = props.props;
  const Icon: * = variantIcon[variant];

  const { t } = props;

  return (
    <SnackbarContent
      classes={{
        root: `${styles.snackbarContent} ${styles[variant]}`,
        message: styles.snackbarColMessage,
        action: styles.snackbarColAction,
      }}
      aria-describedby="client-snackbar"
      elevation={0}
      message={
        <span id="client-snackbar" className={`${styles.snackbarMessage}`}>
          <svg className={`${styles.icon}`}>
            <use xlinkHref={Icon} />
          </svg>
          {message}
        </span>
      }
      action={
        linkto && (
          <Link className={styles.snackbarAction} to={linkto || ''}>
            <Button>{t('general:actions.view')}</Button>
          </Link>
        )
      }
      {...other}
    />
  );
}

export default translate()(MySnackbarContent);
